/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
import { Directive } from '@angular/core';
var IonicSelectableItemTemplateDirective = /** @class */ (function () {
    function IonicSelectableItemTemplateDirective() {
    }
    IonicSelectableItemTemplateDirective.decorators = [
        { type: Directive, args: [{
                    selector: '[ionicSelectableItemTemplate]'
                },] }
    ];
    return IonicSelectableItemTemplateDirective;
}());
export { IonicSelectableItemTemplateDirective };
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW9uaWMtc2VsZWN0YWJsZS1pdGVtLXRlbXBsYXRlLmRpcmVjdGl2ZS5qcyIsInNvdXJjZVJvb3QiOiJuZzovL2lvbmljLXNlbGVjdGFibGUvIiwic291cmNlcyI6WyJzcmMvYXBwL2NvbXBvbmVudHMvaW9uaWMtc2VsZWN0YWJsZS9pb25pYy1zZWxlY3RhYmxlLWl0ZW0tdGVtcGxhdGUuZGlyZWN0aXZlLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7QUFBQSxPQUFPLEVBQUUsU0FBUyxFQUFFLE1BQU0sZUFBZSxDQUFDO0FBRTFDO0lBQUE7SUFHb0QsQ0FBQzs7Z0JBSHBELFNBQVMsU0FBQztvQkFDVCxRQUFRLEVBQUUsK0JBQStCO2lCQUMxQzs7SUFDbUQsMkNBQUM7Q0FBQSxBQUhyRCxJQUdxRDtTQUF4QyxvQ0FBb0MiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgeyBEaXJlY3RpdmUgfSBmcm9tICdAYW5ndWxhci9jb3JlJztcblxuQERpcmVjdGl2ZSh7XG4gIHNlbGVjdG9yOiAnW2lvbmljU2VsZWN0YWJsZUl0ZW1UZW1wbGF0ZV0nXG59KVxuZXhwb3J0IGNsYXNzIElvbmljU2VsZWN0YWJsZUl0ZW1UZW1wbGF0ZURpcmVjdGl2ZSB7IH1cbiJdfQ==